import { IndexedFiles, PlaygroundFs } from '../../../state/files-store';
import { ModelUpdate } from './parent-types';

export function toParentModel(fs: PlaygroundFs, mainFile: string): ModelUpdate {
	const { files } = fs;

	if (!files) return { files: undefined };

	const formattedFiles: IndexedFiles = Object.assign(
		{},
		...Object.entries(files)
			.filter(([filepath, file]) => !!file.isFile)
			.map(([filepath, file]) => ({ [filepath]: file }))
	);

	return {
		files: formattedFiles,
		mainFile: mainFile,
	};
}